<template> 
    <img v-lazy="src"/>
</template>

<script>
export default {
  name: "lazy-img",
  props: ["src"],
};
</script>